import React from 'react';

import { SubHeading } from '../../components';
import { images } from '../../constants';

const FindUs = () => (
  <div className="app__bg app__wrapper section__padding" id="contact">
    <div className="app__wrapper_info">
      <SubHeading title="Contact" />
      <h1 className="headtext__cormorant" style={{marginBottom: '3rem'}}>Clipper Craft</h1>
      <div className="app__wrapper-content">
        <p className="p__opensans">Jl. Samanhudi No.49-51, Pasar Baru. Jakarta Pusat. 10710</p>
        <p className="p__cormorant" style={{ color: "#DCCA87", margin: "2rem 0"}}>Opening Hours</p>
        <p className="p__opensans">Senin - Jumat: 10:00 - 21:00 </p>
        <p className="p__opensans">Sabtu - Minggu: 10:00 - 17:00 </p>
        <button type="button" className="custom__button" style={{ marginTop: "2rem"}}>Booking</button>
      </div>
    </div>
    <div className="app__wrapper_img">
      <img src={images.findus} alt="findus" />
    </div>
  </div>
);

export default FindUs;
